import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService'
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"

export const getUsersAdmin = createAsyncThunk(
    'users/getUsersAdmin',
    async (data) => {
        console.log(data);
        return await axiosService.get(`${API_ENDPOINT}/admin/admin`, {
            params: {
                page: data.page,
                limit: data.limit
            }
        }).then((res) => {
            return res.data;
        });
    }
);

export const createUserAdmin = createAsyncThunk(
    'users/createUsersAdmin',
    async (data) => {
        console.log('createAdmin', data);
        return await axiosService.post(`${API_ENDPOINT}/admin/admin/`, data).then((res) => {
            // if (res.data.code == 0) {
            //     toast.success('Hoàn tất thêm tài khoản quản trị !');
            // } else {
            //     toast.error(`Lỗi !: ${JSON.stringify(res.data.mess)}`);
            //     console.log(res.data);
            // }
            return res.data;
        }).catch((err) => console.log(err));
    }
);

export const updateUserAdmin = createAsyncThunk(
    'users/updateUsersAdmin',
    async (data) => {
        const updateData = {
            "fullname": data.fullname,
            "username": data.username,
            "password": data.password,
            "role": data.role,
            "organization_id": data.organization_id,
            "is_active": data.is_active
        }
        return await axiosService.put(`${API_ENDPOINT}/admin/admin/${data.id}`, updateData).then((res) => {
            return res;
        }).catch((err) => console.log(err));
    }
)

const usersSlice = createSlice({
    name: 'users',
    initialState: {
        loading: false,
        modal: false,
        data: [],
        total_page: 0,
        limit: 0,
        dataOrganizations: [],
        dataDetails: null,
        error: null
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        }
    },
    extraReducers: {
        [getUsersAdmin.pending]: (state) => {
            state.loading = true;
        },
        [getUsersAdmin.fulfilled]: (state, { payload }) => {
            state.data = payload.data.data;
            state.limit = payload.data.limit;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [getUsersAdmin.rejected]: (state) => {
            toast.error(`Lấy danh sách không thành công !`);
        },
        [createUserAdmin.fulfilled]: (state, { payload }) => {
            state.loading = false;
            switch (payload.code) {
                case 0: {
                    toast.success('Hoàn tất thêm tài khoản quản trị !');
                    state.modal = false;
                    break;
                }
                case 2: {
                    toast.error('Email đã tồn tại !');
                    state.modal = true;
                    break;
                }
            }
            if (payload.data.fullname) {
                state.data.unshift(payload.data);
            }
        },
        [createUserAdmin.rejected]: (state, action) => {
            state.error = action.payload;
        },
        [updateUserAdmin.fulfilled]: (state, { payload }) => {
            switch (payload.data.code) {
                case 0: {
                    toast.success('Cập nhật dữ liệu thành công !');
                    state.modal = false;
                    break;
                }
                case 3: {
                    toast.error('Email đã tồn tại !');
                    state.modal = true;
                    break;
                }
            }
            const index = state.data.findIndex(_item => _item.id === payload.data.data.id);
            state.data[index] = payload.data.data;
        },
        [updateUserAdmin.rejected]: (state, action) => {
            state.error = action.payload;
        },
    }
});

export const { getModal, removeModal } = usersSlice.actions;

export default usersSlice.reducer;